import { render, staticRenderFns } from "./maintenanceitems.vue?vue&type=template&id=533efdac&scoped=true&"
import script from "./maintenanceitems.vue?vue&type=script&lang=js&"
export * from "./maintenanceitems.vue?vue&type=script&lang=js&"
import style0 from "./maintenanceitems.vue?vue&type=style&index=0&id=533efdac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533efdac",
  null
  
)

export default component.exports